export enum FeatureType {
  crud = 'crud',
  bool = 'bool',
}
